import React, {Component} from 'react';
import SearchDropdown from '../widgets/SearchDropdown';
import fetchJson from '../fetchJson';
import './LocationSearchDropdown.css';

/**
 * Location drop down that executes a search on the back-end
 */
class LocationSearchDropdown extends Component {
	constructor(props) {
		super(props);

		this.performSearch = async query => {
			try {
				return (await fetchJson(`/api/location/search/${encodeURIComponent(query)}`)).map(item => ({
					...item,
					label: item.suburb,
					extra: item.postcode
				}));
			} catch (e) {
				this.props.onError();
			}
		};

		this.renderItem = ({
			suburb,
			suburbUuid,
			postcode,
			state,
			country,
			isHighlighted,
			onClick,
			onMouseOver,
			onMouseOut
		}) => {
			return (
				<li
					className={`SearchDropdown-item ${isHighlighted ? 'highlighted' : ''}`}
					onMouseDown={() => onClick(suburbUuid)}
					onMouseOver={() => onMouseOver(suburbUuid)}
					onMouseOut={() => onMouseOut(suburbUuid)}>
					<div className="SearchDropdown-name">{suburb}</div>
					<div className="SearchDropdown-extra">{postcode}</div>
				</li>
			);
		};

		this.keyFunc = item => item.suburbUuid;
	}

	render() {
		return (
			<SearchDropdown
				className="LocationSearchDropdown"
				wrapperClassName={'LocationSearchDropdown ' + this.props.className}
				value={this.props.value}
				keyFunc={this.keyFunc}
				onSearch={this.performSearch}
				onSelect={this.props.onSelect}
				itemRenderer={this.renderItem}
				placeholder="Enter a suburb or postcode to search"
				extra={<span className="icon icon-search" />}
				// onShowMore={this.props.onShowMore}
				scrollInOnShow={this.props.scrollInOnShow}
				emptyMessage="Enter a suburb or postcode to search"
				scrollIntoViewElement={this.props.scrollIntoViewElement}
			/>
		);
	}
}

export default LocationSearchDropdown;



// WEBPACK FOOTER //
// ./src/search/LocationSearchDropdown.js